/**
 * en-GB messages added by shared reception task W-SR3 (docs/SHARED-RECEPTION-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts. UK English only.
 */
export const wSr3EnGB = {
    'srb.shell.building': 'Building: {name}',
    'srb.adminOnly': 'Only building administrators can open this page.',
    // Settings
    'srb.settings.title': 'Building settings',
    'srb.settings.desc': 'How the shared tablet, alerts, evacuations and marshal phones work for this building.',
    'srb.settings.saved': 'Settings saved.',
    'srb.settings.save': 'Save settings',
    'srb.settings.zeroOff': '0 turns this off.',
    'srb.settings.kiosk': 'Shared tablet',
    'srb.settings.kioskDesc': 'What visitors see on the shared tablet.',
    'srb.settings.welcome': 'Welcome message',
    'srb.settings.welcomeHint': 'Shown on the tablet welcome screen. Leave empty for the standard message.',
    'srb.settings.privacy': 'Privacy line',
    'srb.settings.privacyHint': 'A short line under the welcome message. Leave empty for the standard line.',
    'srb.settings.pickerSearch': 'Show a search box from this many companies',
    'srb.settings.pickerSearchHint': 'On the company list. 0 never shows it.',
    'srb.settings.idle': 'Return to the welcome screen after (seconds)',
    'srb.settings.idleHint': 'When nobody touches the tablet. 0 never returns (not recommended).',
    'srb.settings.nfc': 'Let companies enrol their own cards on the tablet',
    'srb.settings.nfcHint': 'Off by default. A company can then put the tablet into card enrolment for its own people.',
    'srb.settings.alerts': 'Tablet alerts',
    'srb.settings.alertsDesc': 'We email the alert address when a tablet needs attention.',
    'srb.settings.alertEmail': 'Alert email address',
    'srb.settings.alertEmailHint': 'Leave empty to send no alert emails.',
    'srb.settings.offlineMinutes': 'Tablet offline for (minutes)',
    'srb.settings.battery': 'Battery below (%)',
    'srb.settings.printerFault': 'Printer faults',
    'srb.settings.appOutdated': 'Tablet app out of date',
    'srb.settings.evacuation': 'Evacuation',
    'srb.settings.evacuationDesc': 'Who can start a building evacuation, and what the lists show.',
    'srb.settings.kioskStart': 'Starting an evacuation on the tablet',
    'srb.settings.kioskStartHint': 'Set the building PIN below before choosing "With the building PIN".',
    'srb.settings.kioskStart.off': 'Not allowed',
    'srb.settings.kioskStart.pin': 'With the building PIN',
    'srb.settings.kioskStart.open': 'Without a PIN',
    'srb.settings.memberStarts': 'A real evacuation by a company evacuates the whole building',
    'srb.settings.memberStartsHint': 'When a company starts a real evacuation at its site, the building evacuation starts too.',
    'srb.settings.memberDrills': 'A drill by a company also starts a building drill',
    'srb.settings.memberDrillsHint': 'Off by default, so company drills stay with the company.',
    'srb.settings.groupLabel': 'Show Visitor, Staff or Contractor on the building list',
    'srb.settings.groupLabelHint': 'A company can also switch this off for its own people.',
    'srb.settings.phones': 'Marshal phones',
    'srb.settings.phonesDesc': 'Fire marshals can use the CloudSign app on their phone to see the building list, even offline.',
    'srb.settings.phonesOn': 'Allow marshal phones',
    'srb.settings.phonesOnHint': 'Off stops new invitations, refuses enrolled phones and stops keeping the on-site list for phones.',
    'srb.settings.refresh': 'Refresh the phone list every (minutes)',
    'srb.settings.refreshHint': 'While the app is open.',
    'srb.settings.cacheExpiry': 'Phone list expires after (hours)',
    'srb.settings.cacheExpiryHint': 'The phone deletes its saved list after this long.',
    'srb.settings.canStart': 'Marshals can start an evacuation from the phone',
    'srb.settings.canStartHint': 'This also works offline.',
    'srb.settings.appLock': 'Require the app lock',
    'srb.settings.appLockHint': 'The phone must have a PIN or fingerprint lock set in the app before it shows the list.',
    // Evacuation PIN
    'srb.pin.title': 'Building evacuation PIN',
    'srb.pin.set': 'PIN set',
    'srb.pin.notSet': 'No PIN yet',
    'srb.pin.desc': 'Asked for when someone starts or ends an evacuation on the shared tablet. We never show the PIN again once saved.',
    'srb.pin.field': 'New PIN',
    'srb.pin.hint': '4 to 8 digits.',
    'srb.pin.setIt': 'Set PIN',
    'srb.pin.change': 'Change PIN',
    'srb.pin.saved': 'PIN saved.',
    // Companies
    'srb.companies.title': 'Companies',
    'srb.companies.desc': 'The companies that share this building\'s tablet, in the order visitors see them.',
    'srb.companies.list': 'Order on the tablet',
    'srb.companies.orderHint': 'Drag a company, or use the move buttons, then save.',
    'srb.companies.readOnly': 'Only building administrators can change the order.',
    'srb.companies.save': 'Save order',
    'srb.companies.saved': 'Order saved.',
    'srb.companies.empty': 'No companies are using this tablet yet.',
    'srb.companies.unnamed': 'Unnamed company',
    'srb.companies.signInPaused': 'Sign-in paused',
    'srb.companies.notOnPhones': 'Not on marshal phone lists',
    'srb.companies.others': 'Not on the tablet',
    'srb.companies.othersDesc': 'Companies that have left, declined or have not yet accepted.',
    // Devices
    'srb.devices.title': 'Shared tablets',
    'srb.devices.desc': 'Pair a new tablet, check how each one is doing and send it a remote action.',
    'srb.devices.empty': 'No tablets are paired yet. Create a pairing code above and enter it on the tablet.',
    'srb.devices.list': 'Tablets',
    'srb.devices.online': 'Online',
    'srb.devices.offline': 'Offline',
    'srb.devices.version': 'App {version}',
    'srb.devices.seen': 'Last seen',
    'srb.devices.never': 'Never',
    'srb.devices.battery': 'Battery',
    'srb.devices.charging': 'charging',
    'srb.devices.unknown': 'Not reported',
    'srb.devices.printer': 'Badge printer',
    'srb.devices.noPrinter': 'None set up',
    'srb.devices.companies': 'Companies on this tablet',
    'srb.devices.noCompanies': 'None',
    'srb.devices.alerts': 'Email an alert when this tablet needs attention',
    'srb.devices.actions': 'Actions for {name}',
    'srb.devices.reload': 'Reload settings',
    'srb.devices.restart': 'Restart app',
    'srb.devices.testPrint': 'Test print',
    'srb.devices.unpair': 'Unpair',
    'srb.devices.unpairConfirm': 'Unpair {name}',
    'srb.devices.unpaired': 'Tablet unpaired.',
    'srb.devices.message': 'Message to show on the tablet',
    'srb.devices.messageHint': 'Shown for one minute.',
    'srb.devices.showMessage': 'Show message',
    'srb.devices.sent': 'Sent to the tablet.',
    'srb.devices.showCommands': 'Show recent actions',
    'srb.devices.hideCommands': 'Hide recent actions',
    'srb.devices.noCommands': 'Nothing sent yet.',
    'srb.devices.result.ok': 'Done',
    'srb.devices.result.failed': 'Failed',
    'srb.devices.result.waiting': 'Waiting for the tablet',
    'srb.devices.action.reload_config': 'Reload settings',
    'srb.devices.action.restart_app': 'Restart app',
    'srb.devices.action.test_print': 'Test print',
    'srb.devices.action.show_message': 'Show message',
    'srb.devices.action.unpair': 'Unpair',
    'srb.devices.action.nfc_enrol': 'Card enrolment',
    'srb.devices.action.evacuation_mode': 'Evacuation mode',
    'srb.pair.title': 'Pair a new tablet',
    'srb.pair.desc': 'Make a one-off code and enter it on the tablet when you set it up.',
    'srb.pair.name': 'Tablet name',
    'srb.pair.nameHint': 'For example "Main reception".',
    'srb.pair.create': 'Create pairing code',
    'srb.pair.shown': 'Enter this code on the tablet. It works once and runs out at {time}.',
    'srb.pair.code': 'Pairing code',
    // Marshal phones
    'srb.phones.title': 'Marshal phones',
    'srb.phones.desc': 'Invite fire marshals to use the CloudSign app on their own phone for the building list.',
    'srb.phones.off': 'Marshal phones are turned off in the building settings. Turn them on to send invitations.',
    'srb.phones.staff': 'Building staff',
    'srb.phones.staffDesc': 'Invite a person to enrol their phone. They get an email with a one-off link to open on the phone.',
    'srb.phones.invite': 'Invite phone',
    'srb.phones.inviteNamed': 'Invite a phone for {name}',
    'srb.phones.enrolled': 'Enrolled phones',
    'srb.phones.enrolledDesc': 'Removing a phone signs it out of the building at once.',
    'srb.phones.col.person': 'Person',
    'srb.phones.col.role': 'Role',
    'srb.phones.col.phones': 'Phones',
    'srb.phones.col.phone': 'Phone',
    'srb.phones.col.enrolled': 'Enrolled',
    'srb.phones.col.seen': 'Last seen',
    'srb.phones.col.expires': 'Expires',
    'srb.phones.col.actions': 'Actions',
    'srb.phones.never': 'Never',
    'srb.phones.noExpiry': 'Does not expire',
    'srb.phones.removedBadge': 'Removed',
    'srb.phones.remove': 'Remove',
    'srb.phones.removeNamed': 'Remove the phone of {name}',
    'srb.phones.removed': 'Phone removed.',
    'srb.invite.sent': 'Invitation sent to {name} at {email}.',
    'srb.invite.expires': 'The link stops working at {time}.',
    'srb.invite.onceOnly': 'It enrols one phone, once. Open it on the phone that has the CloudSign app.',
    'srb.invite.linkLabel': 'Invitation link, or scan the code with the phone:',
    'srb.invite.qrAlt': 'QR code of the invitation link for {name}',
    'srb.invite.copy': 'Copy link',
    'srb.invite.copied': 'Copied',
    'srb.invite.done': 'Done',
    'srb.invite.page.title': 'Building fire marshal invitation',
    'srb.invite.page.body': 'This link enrols your phone for the building fire list. Open this link on the phone with the CloudSign app.',
    // Evacuation
    'srb.evac.title': 'Building evacuation',
    'srb.evac.desc': 'Everyone on site across every company. Names, company and status only.',
    'srb.evac.none': 'No evacuation is running',
    'srb.evac.noneDesc': 'Start one only if the whole building needs to be evacuated, or for a drill.',
    'srb.evac.startReal': 'Start real evacuation',
    'srb.evac.startRealConfirm': 'Yes, start a real evacuation',
    'srb.evac.startDrill': 'Start drill',
    'srb.evac.startDrillConfirm': 'Yes, start a drill',
    'srb.evac.status': 'Evacuation status',
    'srb.evac.startedBy': 'Started {time} by {by}.',
    'srb.evac.kind.real': 'Real evacuation',
    'srb.evac.kind.drill': 'Drill',
    'srb.evac.source.kiosk': 'Shared tablet',
    'srb.evac.source.building': 'Building area',
    'srb.evac.source.member': 'A company',
    'srb.evac.source.phone': 'Marshal phone',
    'srb.evac.source.system': 'System',
    'srb.evac.end': 'End evacuation',
    'srb.evac.endConfirm': 'Yes, end the evacuation',
    'srb.evac.status.unaccounted': 'Not accounted for',
    'srb.evac.status.safe': 'Safe',
    'srb.evac.status.off_site': 'Off site',
    'srb.evac.status.missing': 'Missing',
    'srb.evac.filter': 'Show',
    'srb.evac.filter.unaccounted': 'Not accounted for',
    'srb.evac.filter.safe': 'Safe',
    'srb.evac.filter.off_site': 'Off site',
    'srb.evac.filter.missing': 'Missing',
    'srb.evac.filter.all': 'Everyone',
    'srb.evac.searchHint': 'Search by name or company',
    'srb.evac.noPeople': 'Nobody is on the list.',
    'srb.evac.noMatch': 'Nobody matches.',
    'srb.evac.check': 'Check',
    'srb.evac.signedIn': 'In {time}',
    'srb.evac.muster': 'Muster point {name}',
    'srb.evac.markFor': 'Mark {name}',
    'srb.evac.markAs': 'Mark {name} as {status}',
    'srb.evac.mark.safe': 'Safe',
    'srb.evac.mark.off_site': 'Off site',
    'srb.evac.mark.missing': 'Missing',
    'srb.evac.undo': 'Undo',
    'srb.evac.undoFor': 'Undo the mark for {name}',
    'srb.evac.offline': 'Offline. Showing the list as it was at {time}. It updates when the connection returns.',
    // History
    'srb.history.title': 'Evacuation history',
    'srb.history.desc': 'Past building evacuations and drills. Counts only, no names.',
    'srb.history.searchHint': 'Search by who started it',
    'srb.history.kind': 'Type',
    'srb.history.kindAll': 'All',
    'srb.history.sort': 'Sort by',
    'srb.history.newest': 'Newest first',
    'srb.history.oldest': 'Oldest first',
    'srb.history.col.started': 'Started',
    'srb.history.col.kind': 'Type',
    'srb.history.col.by': 'Started by',
    'srb.history.col.ended': 'Ended',
    'srb.history.col.companies': 'Companies',
    'srb.history.col.counts': 'Final counts',
    'srb.history.running': 'Running',
    'srb.history.counts': '{unaccounted} not accounted for, {safe} safe, {missing} missing, {offSite} off site',
};
//# sourceMappingURL=w-sr3.js.map